import React from 'react';
import { Box, Container, Paper, Typography, Grid } from '@mui/material';
import EngineeringIcon from '@mui/icons-material/Engineering';
import ScheduleIcon from '@mui/icons-material/Schedule';
import Lottie from 'lottie-react';
import constructionAnimation from './construction.json';

export default function Exams() {
  return (
    <Container maxWidth="xl">
      <Box sx={{ 
        flexGrow: 1, 
        p: { xs: 2, sm: 3, md: 4 },
      }}>
        <Paper elevation={3} sx={{ width: '100%', maxWidth: 800, mx: 'auto', p: 4 }}>
          <Grid container spacing={4}>
            <Grid item xs={12} sx={{ textAlign: 'center' }}>
              <Lottie
                animationData={constructionAnimation}
                style={{ width: 250, height: 250, margin: 'auto' }}
                loop={true}
              />
              <Typography variant="h4" gutterBottom>
                Yapım Aşamasında
              </Typography>
              <Typography variant="subtitle1" color="text.secondary" paragraph>
                Bu bölüm aktif olarak geliştiriliyor. Çok yakında hizmetinizde olacak!
              </Typography>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ textAlign: 'center', p: 2 }}>
                <EngineeringIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
                <Typography variant="h6" gutterBottom>
                  Neler Geliyor?
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Online sınav sistemi, pratik quiz'ler ve interaktif öğrenme araçları
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box sx={{ textAlign: 'center', p: 2 }}>
                <ScheduleIcon sx={{ fontSize: 40, color: 'primary.main', mb: 1 }} />
                <Typography variant="h6" gutterBottom>
                  Tahmini Süre
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Çok yakında kullanıma açılacak. Gelişmeleri takip edin!
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    </Container>
  );
}
